import './Input.css';

const Input = ({ label, ...props }) => {
  return (
    <div className="input-group">
      <input {...props} placeholder=" " />
      <label>{label}</label>
    </div>
  );
};

export default Input; 